import { render, staticRenderFns } from "./MatchCostDetail.vue?vue&type=template&id=48018eca&scoped=true"
import script from "./MatchCostDetail.vue?vue&type=script&lang=js"
export * from "./MatchCostDetail.vue?vue&type=script&lang=js"
import style0 from "./MatchCostDetail.vue?vue&type=style&index=0&id=48018eca&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48018eca",
  null
  
)

export default component.exports